import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./guesthouse.css";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
const statusLabel = { free: "Свободна", busy: "Занята", repair: "На ремонте" };
const payLabel = { cash: "Наличка", terminal: "Терминал", click: "Click", debt: "Долг" };

const GuestHouse = ({ logout, user, API_URL }) => {
    // Редактировать может только admin или подроль "guesthouse", остальные — только просмотр
    const userRole = (user?.role || "").trim().toLowerCase();
    const userSubroles = (user?.subroles || []).map((r) => String(r).trim().toLowerCase());
    const canEdit = userRole === "admin" || userSubroles.includes("guesthouse");

    const [rooms, setRooms] = useState([]);
    const [bookings, setBookings] = useState([]);
    const [dayStatuses, setDayStatuses] = useState([]);
    const [badDays, setBadDays] = useState([]);
    const [currentDate, setCurrentDate] = useState(new Date());

    const [modal, setModal] = useState({
        open: false,
        roomId: null,
        roomName: "",
        day: "",
        weekday: "",
        monthName: "",
        date: "",
    });
    const [cellCurrent, setCellCurrent] = useState([]);
    const [cellPool, setCellPool] = useState([]);
    const [cellDayStatus, setCellDayStatus] = useState("free");
    const [selectedKey, setSelectedKey] = useState("");
    const [poolCount, setPoolCount] = useState(0);

    // модалка управления комнатами (название + вместимость) — по 5 кликам на заголовок
    const [roomsModal, setRoomsModal] = useState(false);
    const titleClickCount = useRef(0);
    const titleClickTimer = useRef(null);
    const [newRoomName, setNewRoomName] = useState("");
    const [newRoomCapacity, setNewRoomCapacity] = useState(1);
    const [editRoomId, setEditRoomId] = useState(null);
    const [editRoomName, setEditRoomName] = useState("");
    const [editRoomCapacity, setEditRoomCapacity] = useState(1);

    // модалка "добавить/изменить бронь"
    const [orderModal, setOrderModal] = useState({ open: false });
    const [editingOrderId, setEditingOrderId] = useState(null);
    const [orderStart, setOrderStart] = useState("");
    const [orderEnd, setOrderEnd] = useState("");
    const [orderNote, setOrderNote] = useState("");
    const [orderPrice, setOrderPrice] = useState(0);
    const [orderMealBreakfast, setOrderMealBreakfast] = useState(false);
    const [orderMealBreakfastPrice, setOrderMealBreakfastPrice] = useState(0);
    const [orderMealDinner, setOrderMealDinner] = useState(false);
    const [orderMealDinnerPrice, setOrderMealDinnerPrice] = useState(0);
    const [orderExtraServices, setOrderExtraServices] = useState([]);
    const [orderGuests, setOrderGuests] = useState([
        { name: "", country: "", passport: "", pay: "cash" },
    ]);

    const [activeTab, setActiveTab] = useState("calendar");
    const [guesthouseOrders, setGuesthouseOrders] = useState([]);
    const [viewOrder, setViewOrder] = useState(null);

    const months = [
        "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
        "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
    ];
    const weekDays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];

    const monthName = months[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    const prevMonth = () => {
        const date = new Date(currentDate);
        date.setMonth(date.getMonth() - 1);
        setCurrentDate(date);
    };
    const nextMonth = () => {
        const date = new Date(currentDate);
        date.setMonth(date.getMonth() + 1);
        setCurrentDate(date);
    };
    const getWeekDay = (day) =>
        weekDays[new Date(currentDate.getFullYear(), currentDate.getMonth(), day).getDay()];
    const pad2 = (n) => String(n).padStart(2, "0");
    const dateStr = (day) =>
        `${currentDate.getFullYear()}-${pad2(currentDate.getMonth() + 1)}-${pad2(day)}`;

    // ── Загрузка комнат ──
    const getRooms = async () => {
        try {
            const res = await axios.post(`${API_URL}/getGuestRooms`);
            setRooms(res.data);
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        getRooms();
    }, []);

    // ── Загрузка занятости + статусов + red-days на месяц ──
    const refreshMonthData = async () => {
        try {
            const [assignRes, coverRes] = await Promise.all([
                axios.post(`${API_URL}/getGuesthouseMonthAssignments`, {
                    year: currentDate.getFullYear(),
                    month: currentDate.getMonth() + 1,
                }),
                axios.post(`${API_URL}/getGuesthouseMonthCoverage`, {
                    year: currentDate.getFullYear(),
                    month: currentDate.getMonth() + 1,
                }),
            ]);
            setBookings(assignRes.data.bookings || []);
            setDayStatuses(assignRes.data.statuses || []);
            setBadDays(coverRes.data.badDays || []);
        } catch (err) {
            console.error("Ошибка загрузки занятости:", err);
        }
    };
    useEffect(() => {
        refreshMonthData();
    }, [currentDate]);

    // ─── Realtime: обновление при действиях других операторов ───
    useEffect(() => {
        const socketUrl = API_URL.replace(/\/api\/?$/, "");
        const socket = io(socketUrl);

        socket.on("calendar:update", () => {
            refreshMonthData();

            if (activeTab === "list") {
                getGuesthouseOrdersList();
            }

            if (modal.open) {
                refreshCell();
            }
        });

        return () => socket.disconnect();
    }, [API_URL, activeTab, modal.open, modal.roomId, modal.date]);

    const getGuesthouseOrdersList = async () => {
        try {
            const res = await axios.post(`${API_URL}/getGuesthouseOrdersList`, {
                year: currentDate.getFullYear(),
                month: currentDate.getMonth() + 1,
            });
            setGuesthouseOrders(res.data.orders || []);
        } catch (err) {
            console.error("Ошибка загрузки списка броней:", err);
        }
    };
    useEffect(() => {
        if (activeTab === "list") {
            getGuesthouseOrdersList();
        }
    }, [activeTab, currentDate]);

    const deleteGuesthouseOrder = async (id, title) => {
        if (!canEdit) return;
        if (!window.confirm(`Удалить бронь "${title}"? Она будет снята со всех комнат.`)) return;
        try {
            await axios.post(`${API_URL}/deleteGuesthouseOrder`, { id });
            toast.success("Бронь удалена");
            getGuesthouseOrdersList();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось удалить бронь");
        }
    };

    const isBadDay = (day) => badDays.includes(day);

    const getBookingsForCell = (roomId, day) => {
        const ds = dateStr(day);
        return bookings.filter((b) => b.roomId === roomId && b.dateStart <= ds && b.dateEnd >= ds);
    };
    const getDayStatus = (roomId, day) => {
        const ds = dateStr(day);
        const found = dayStatuses.find((s) => s.roomId === roomId && s.date === ds);
        return found ? found.status : "free";
    };

    // ── Управление комнатами (5 кликов на заголовок) ──
    const handleTitleClick = () => {
        if (!canEdit) return;
        titleClickCount.current += 1;
        if (titleClickTimer.current) clearTimeout(titleClickTimer.current);

        if (titleClickCount.current >= 5) {
            titleClickCount.current = 0;
            setNewRoomName("");
            setNewRoomCapacity(1);
            setEditRoomId(null);
            setRoomsModal(true);
            return;
        }

        titleClickTimer.current = setTimeout(() => {
            titleClickCount.current = 0;
        }, 1500);
    };

    const addRoom = async () => {
        if (!canEdit) return;
        if (!newRoomName.trim()) {
            toast.error("Укажите название комнаты");
            return;
        }
        try {
            await axios.post(`${API_URL}/addGuestRoom`, {
                name: newRoomName.trim(),
                capacity: Math.max(1, Number(newRoomCapacity) || 1),
            });
            toast.success("Комната добавлена");
            setNewRoomName("");
            setNewRoomCapacity(1);
            getRooms();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось добавить комнату");
        }
    };

    const startEditRoom = (room) => {
        setEditRoomId(room.id);
        setEditRoomName(room.name);
        setEditRoomCapacity(room.capacity);
    };
    const saveEditRoom = async () => {
        if (!canEdit) return;
        if (!editRoomName.trim()) {
            toast.error("Укажите название комнаты");
            return;
        }
        try {
            await axios.post(`${API_URL}/updateGuestRoom`, {
                id: editRoomId,
                name: editRoomName.trim(),
                capacity: Math.max(1, Number(editRoomCapacity) || 1),
            });
            toast.success("Комната обновлена");
            setEditRoomId(null);
            getRooms();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось изменить комнату");
        }
    };
    const deleteRoom = async (id, name) => {
        if (!canEdit) return;
        if (!window.confirm(`Удалить комнату "${name}"? Все её брони тоже будут удалены.`)) return;
        try {
            await axios.post(`${API_URL}/deleteGuestRoom`, { id });
            toast.success("Комната удалена");
            getRooms();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось удалить комнату");
        }
    };

    // ── Модалка ячейки ──
    const openCell = async (room, day) => {
        const ds = dateStr(day);
        setModal({
            open: true,
            roomId: room.id,
            roomName: room.name,
            day,
            weekday: getWeekDay(day),
            monthName,
            date: ds,
        });
        setSelectedKey("");
        setPoolCount(0);

        try {
            const res = await axios.post(`${API_URL}/getGuesthouseCellInfo`, {
                roomId: room.id,
                date: ds,
            });
            setCellPool(res.data.pool || []);
            setCellCurrent(res.data.current || []);
            setCellDayStatus(res.data.dayStatus || "free");
        } catch (err) {
            console.error("Ошибка загрузки данных ячейки:", err);
            setCellPool([]);
            setCellCurrent([]);
            setCellDayStatus("free");
        }
    };

    const refreshCell = async () => {
        try {
            const res = await axios.post(`${API_URL}/getGuesthouseCellInfo`, {
                roomId: modal.roomId,
                date: modal.date,
            });
            setCellPool(res.data.pool || []);
            setCellCurrent(res.data.current || []);
            setCellDayStatus(res.data.dayStatus || "free");
        } catch (err) {
            console.error(err);
        }
    };

    const changeDayStatus = async (status) => {
        if (!canEdit) return;
        try {
            await axios.post(`${API_URL}/updateGuesthouseDayStatus`, {
                roomId: modal.roomId,
                date: modal.date,
                status,
            });
            setCellDayStatus(status);
            if (status !== "free") {
                setSelectedKey("");
                setPoolCount(0);
            }
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось изменить статус");
        }
    };

    const removeBooking = async (bookingId) => {
        if (!canEdit) return;
        try {
            await axios.post(`${API_URL}/clearGuesthouseBooking`, { bookingId });
            toast.success("Бронь убрана");
            refreshCell();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось убрать бронь");
        }
    };

    const addToRoom = async () => {
        if (!canEdit || !selectedKey || poolCount <= 0) return;
        try {
            const res = await axios.post(`${API_URL}/assignGuesthouseRoom`, {
                roomId: modal.roomId,
                key: selectedKey,
                count: poolCount,
            });
            if (res.data.status === "error") {
                toast.error(res.data.message || "Не удалось добавить");
                return;
            }
            toast.success("Добавлено в комнату");
            setSelectedKey("");
            setPoolCount(0);
            refreshCell();
            refreshMonthData();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось добавить");
        }
    };

    // ── Модалка брони ──
    const openOrderModal = (order = null) => {
        if (order) {
            setEditingOrderId(order.id);
            setOrderStart(order.dateStart);
            setOrderEnd(order.dateEnd);
            setOrderNote(order.note || "");
            setOrderPrice(order.price || 0);
            setOrderMealBreakfast(order.mealBreakfast || false);
            setOrderMealBreakfastPrice(order.mealBreakfastPrice || 0);
            setOrderMealDinner(order.mealDinner || false);
            setOrderMealDinnerPrice(order.mealDinnerPrice || 0);
            setOrderExtraServices(order.extraServices?.length ? order.extraServices : []);
            setOrderGuests(
                order.guests?.length
                    ? order.guests.map((g) => ({ ...g }))
                    : [{ name: "", country: "", passport: "", pay: "cash" }]
            );
        } else {
            const today = dateStr(new Date().getDate());
            setEditingOrderId(null);
            setOrderStart(today);
            setOrderEnd(today);
            setOrderNote("");
            setOrderPrice(0);
            setOrderMealBreakfast(false);
            setOrderMealBreakfastPrice(0);
            setOrderMealDinner(false);
            setOrderMealDinnerPrice(0);
            setOrderExtraServices([]);
            setOrderGuests([{ name: "", country: "", passport: "", pay: "cash" }]);
        }
        setOrderModal({ open: true });
    };
    const addOrderGuestSlot = () => {
        setOrderGuests((prev) => [...prev, { name: "", country: "", passport: "", pay: "cash" }]);
    };
    const removeOrderGuestSlot = (idx) => {
        setOrderGuests((prev) => prev.filter((_, i) => i !== idx));
    };
    const updateOrderGuestField = (idx, field, value) => {
        setOrderGuests((prev) => prev.map((g, i) => (i === idx ? { ...g, [field]: value } : g)));
    };

    const addExtraService = () => {
        setOrderExtraServices((prev) => [...prev, { name: "", price: 0 }]);
    };
    const removeExtraService = (idx) => {
        setOrderExtraServices((prev) => prev.filter((_, i) => i !== idx));
    };
    const updateExtraService = (idx, field, value) => {
        setOrderExtraServices((prev) =>
            prev.map((s, i) => (i === idx ? { ...s, [field]: value } : s))
        );
    };

    const nightsBetween = (start, end) => {
        if (!start || !end) return 0;
        return Math.max(0, Math.round((new Date(end) - new Date(start)) / 86400000));
    };
    const extraServicesTotal = (list) =>
        (list || []).reduce((s, x) => s + (Number(x.price) || 0), 0);
    const orderTotal = () => {
        const meal =
            (orderMealBreakfast ? Number(orderMealBreakfastPrice) || 0 : 0) +
            (orderMealDinner ? Number(orderMealDinnerPrice) || 0 : 0);
        return (Number(orderPrice) || 0) + meal + extraServicesTotal(orderExtraServices);
    };

    const saveOrder = async () => {
        if (!canEdit) return;
        const guests = orderGuests.filter((g) => g.name.trim());
        if (!guests.length) {
            toast.error("Добавьте хотя бы одного гостя");
            return;
        }
        if (!orderStart || !orderEnd || orderStart > orderEnd) {
            toast.error("Проверьте даты");
            return;
        }
        const payload = {
            dateStart: orderStart,
            dateEnd: orderEnd,
            guests,
            note: orderNote,
            price: Number(orderPrice) || 0,
            mealBreakfast: orderMealBreakfast,
            mealBreakfastPrice: Number(orderMealBreakfastPrice) || 0,
            mealDinner: orderMealDinner,
            mealDinnerPrice: Number(orderMealDinnerPrice) || 0,
            extraServices: orderExtraServices.filter((s) => s.name.trim()),
        };
        try {
            const res = editingOrderId
                ? await axios.post(`${API_URL}/updateGuesthouseOrder`, { id: editingOrderId, ...payload })
                : await axios.post(`${API_URL}/addGuesthouseOrder`, payload);
            if (res.data.status === "error") {
                toast.error(res.data.message || "Не удалось сохранить бронь");
                return;
            }
            toast.success(editingOrderId ? "Бронь обновлена" : "Бронь создана — распределите по комнатам в календаре");
            setOrderModal({ open: false });
            setViewOrder(null);
            refreshMonthData();
            if (activeTab === "list") getGuesthouseOrdersList();
        } catch (err) {
            console.error(err);
            toast.error("Не удалось сохранить бронь");
        }
    };

    const selectedPoolItem = cellPool.find((t) => t.key === selectedKey);

    return (
        <div className="guesthouse">
            <div className="gh-flex">
                <div className="gh-section1">
                    <div className="gh-section1-text" onClick={handleTitleClick} style={{ cursor: "default", userSelect: "none" }}>
                        Гостевой дом <br />Занятость
                    </div>
                    <div className="gh-section1-dateselect">
                        <button className="gh-month-btn" onClick={prevMonth}>
                            <i className="fa-solid fa-angle-left"></i>
                        </button>
                        <span className="gh-month-title">{monthName} {year}</span>
                        <button className="gh-month-btn" onClick={nextMonth}>
                            <i className="fa-solid fa-angle-right"></i>
                        </button>
                    </div>
                    <div style={{ display: "flex", gap: 10 }}>
                        {canEdit ? (
                            <button className="yc-add-yurt-btn" onClick={() => openOrderModal()}>
                                <i className="fa-solid fa-plus"></i> Добавить бронь
                            </button>
                        ) : (
                            <span className="gh-readonly-badge"><i className="fa-solid fa-eye"></i> Только просмотр</span>
                        )}
                    </div>
                </div>

                <div className="gh-tabs-bar">
                    <button
                        className={`gh-tab-btn ${activeTab === "calendar" ? "active" : ""}`}
                        onClick={() => setActiveTab("calendar")}
                    >
                        Календарь
                    </button>
                    <button
                        className={`gh-tab-btn ${activeTab === "list" ? "active" : ""}`}
                        onClick={() => setActiveTab("list")}
                    >
                        Список броней
                    </button>
                </div>

                {activeTab === "calendar" ? (
                    <div className="gh-section2">
                        <table className="gh-table">
                            <thead>
                                <tr>
                                    <th className="gh-sticky-col gh-room-modelname">Комната</th>
                                    {days.map((day) => (
                                        <th key={day} className={isBadDay(day) ? "gh-bad-day" : ""}>
                                            <div className="gh-day-num">{day}</div>
                                            <div className="gh-weekday">{getWeekDay(day)}</div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {rooms.map((room) => (
                                    <tr key={room.id}>
                                        <td className="gh-sticky-col gh-room-name">
                                            <div className="gh-room-name-text">{room.name}</div>
                                            <div className="gh-room-capacity-text">до {room.capacity} чел.</div>
                                        </td>

                                        {days.map((day) => {
                                            const dayBookings = getBookingsForCell(room.id, day);
                                            const hasCancelled = dayBookings.some((b) => b.isCancelled);
                                            const dStatus = getDayStatus(room.id, day);
                                            return (
                                                <td
                                                    key={day}
                                                    className={`gh-day-cell ${dayBookings.length ? "gh-day-cell-assigned" : ""} ${hasCancelled ? "gh-day-cell-cancelled" : ""} ${dStatus !== "free" ? `gh-cell-${dStatus}` : ""}`}
                                                    onClick={() => openCell(room, day)}
                                                >
                                                    {dayBookings.map((b) => {
                                                        let line = `№${b.orderNumber} — ${b.title} (${b.count})`;
                                                        if (b.isCancelled) line += " (отменён)";
                                                        return (
                                                            <div
                                                                key={b.bookingId}
                                                                className={`gh-cell-line ${b.isCancelled ? "gh-cell-line-cancelled" : ""}`}
                                                            >
                                                                {line}
                                                            </div>
                                                        );
                                                    })}
                                                    {!dayBookings.length && dStatus !== "free" && (
                                                        <div className="gh-cell-line gh-status-line">
                                                            {statusLabel[dStatus]}
                                                        </div>
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="gh-section2">
                        <table className="gh-list-table">
                            <thead>
                                <tr>
                                    <th>№</th>
                                    <th>Гость(и)</th>
                                    <th>Заезд</th>
                                    <th>Выезд</th>
                                    <th>Чел.</th>
                                    <th>Распределено</th>
                                    <th>Комнаты</th>
                                    <th>Заметка</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {guesthouseOrders.length === 0 && (
                                    <tr>
                                        <td colSpan={9} style={{ textAlign: "center", padding: 20, color: "#9b9b9b" }}>
                                            Пока нет броней
                                        </td>
                                    </tr>
                                )}
                                {guesthouseOrders.map((o) => {
                                    const fullyAssigned = o.assignedCount >= o.participantsCount;
                                    return (
                                        <tr
                                            key={o.id}
                                            className={o.isCancelled ? "gh-list-row-cancelled" : ""}
                                            onClick={() => setViewOrder(o)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <td>№{o.orderNumber}</td>
                                            <td>
                                                {o.title}
                                                {o.guests.length > 1 && ` +${o.guests.length - 1}`}
                                            </td>
                                            <td>{o.dateStart}</td>
                                            <td>{o.dateEnd}</td>
                                            <td>{o.participantsCount}</td>
                                            <td>
                                                <span className={fullyAssigned ? "gh-badge-ok" : "gh-badge-pending"}>
                                                    {o.assignedCount} / {o.participantsCount}
                                                </span>
                                            </td>
                                            <td>
                                                {o.rooms.length
                                                    ? o.rooms.map((r) => `${r.name} (${r.count})`).join(", ")
                                                    : "—"}
                                            </td>
                                            <td>{o.note || "—"}</td>
                                            <td>
                                                {canEdit && (
                                                    <button
                                                        className="gh-guest-remove"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            deleteGuesthouseOrder(o.id, o.title);
                                                        }}
                                                    >
                                                        ✕
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            {/* ── Модалка ячейки ── */}
            {modal.open && (
                <div className="gh-overlay" onClick={() => setModal({ ...modal, open: false })}>
                    <div className="gh-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="gh-modal-header">
                            <h2>{modal.roomName} — {modal.day} {modal.monthName} ({modal.weekday})</h2>
                            <button className="gh-modal-close" onClick={() => setModal({ ...modal, open: false })}>✕</button>
                        </div>

                        <div className="gh-modal-section">
                            <label>СТАТУС НА ЭТОТ ДЕНЬ</label>
                            {canEdit ? (
                                <select
                                    className={`gh-status-select gh-status-${cellDayStatus}`}
                                    value={cellDayStatus}
                                    onChange={(e) => changeDayStatus(e.target.value)}
                                >
                                    <option value="free">Свободна</option>
                                    <option value="busy">Занята</option>
                                    <option value="repair">На ремонте</option>
                                </select>
                            ) : (
                                <div className={`gh-status-select gh-status-${cellDayStatus}`}>{statusLabel[cellDayStatus]}</div>
                            )}
                        </div>

                        <div className="gh-modal-section">
                            <label>ТЕКУЩИЕ БРОНИ НА ЭТОТ ДЕНЬ</label>
                            {cellCurrent.length === 0 && (
                                <div className="gh-hint" style={{ textAlign: "center", display: "block" }}>
                                    Пока никто не заселён
                                </div>
                            )}
                            {cellCurrent.map((b) => (
                                <div key={b.bookingId} className="gh-order-row">
                                    <span>
                                        №{b.orderNumber} — {b.title} — {b.count} чел.
                                        {b.dateStart !== modal.date && ` (с ${b.dateStart})`}
                                    </span>
                                    {canEdit && (
                                        <button
                                            type="button"
                                            className="gh-order-remove"
                                            onClick={() => removeBooking(b.bookingId)}
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>

                        {canEdit && (
                        <div className="gh-modal-section">
                            <label>ДОБАВИТЬ БРОНЬ</label>
                            {cellDayStatus !== "free" ? (
                                <div className="gh-hint" style={{ textAlign: "center", display: "block" }}>
                                    Комната помечена как «{statusLabel[cellDayStatus]}» на этот день — добавление недоступно.
                                    Уже назначенные брони остаются, новые добавить нельзя, пока статус не «Свободна».
                                </div>
                            ) : (
                                <>
                                    <select
                                        value={selectedKey}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setSelectedKey(val);
                                            const t = cellPool.find((x) => x.key === val);
                                            setPoolCount(t ? t.maxAvailable : 0);
                                        }}
                                    >
                                        <option value="">— Выберите —</option>
                                        {cellPool
                                            .filter((t) => t.maxAvailable > 0)
                                            .map((t) => (
                                                <option key={t.key} value={t.key}>
                                                    №{t.orderNumber} — {t.title} — свободно {t.maxAvailable} из {t.total}
                                                </option>
                                            ))}
                                    </select>

                                    {cellPool.length > 0 && cellPool.every((t) => t.maxAvailable <= 0) && (
                                        <div className="gh-hint" style={{ textAlign: "center", display: "block", marginTop: 6 }}>
                                            Есть брони на эту дату, но для них нет места (вместимость комнаты исчерпана).
                                        </div>
                                    )}

                                    {selectedPoolItem && (
                                        <div className="gh-stepper" style={{ marginTop: 10 }}>
                                            <button
                                                type="button"
                                                className="gh-stepper-btn"
                                                onClick={() => setPoolCount((c) => Math.max(0, c - 1))}
                                            >
                                                −
                                            </button>
                                            <input
                                                type="number"
                                                min={0}
                                                max={selectedPoolItem.maxAvailable}
                                                value={poolCount}
                                                onChange={(e) =>
                                                    setPoolCount(
                                                        Math.min(selectedPoolItem.maxAvailable, Math.max(0, Number(e.target.value) || 0))
                                                    )
                                                }
                                            />
                                            <button
                                                type="button"
                                                className="gh-stepper-btn"
                                                onClick={() =>
                                                    setPoolCount((c) => Math.min(selectedPoolItem.maxAvailable, c + 1))
                                                }
                                            >
                                                +
                                            </button>
                                            <button
                                                type="button"
                                                className="gh-add-btn"
                                                disabled={poolCount <= 0}
                                                onClick={addToRoom}
                                            >
                                                +
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                        )}

                        <div className="gh-modal-actions">
                            <button className="gh-btn-cancel" onClick={() => setModal({ ...modal, open: false })}>
                                Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Модалка управления комнатами ── */}
            {canEdit && roomsModal && (
                <div className="gh-overlay" onClick={() => setRoomsModal(false)}>
                    <div className="gh-modal gh-rooms-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="gh-modal-header">
                            <h2>Комнаты</h2>
                            <button className="gh-modal-close" onClick={() => setRoomsModal(false)}>✕</button>
                        </div>

                        <div className="gh-modal-section">
                            <label>СУЩЕСТВУЮЩИЕ КОМНАТЫ</label>
                            {rooms.length === 0 && (
                                <div className="gh-hint" style={{ textAlign: "center", display: "block" }}>
                                    Комнат пока нет
                                </div>
                            )}
                            {rooms.map((room) => (
                                <div className="gh-room-row" key={room.id}>
                                    {editRoomId === room.id ? (
                                        <>
                                            <input
                                                className="gh-room-row-input"
                                                value={editRoomName}
                                                onChange={(e) => setEditRoomName(e.target.value)}
                                            />
                                            <input
                                                type="number"
                                                min={1}
                                                className="gh-room-row-capacity"
                                                value={editRoomCapacity}
                                                onChange={(e) => setEditRoomCapacity(e.target.value)}
                                            />
                                            <button className="gh-room-row-save" onClick={saveEditRoom}>✓</button>
                                            <button className="gh-guest-remove" onClick={() => setEditRoomId(null)}>✕</button>
                                        </>
                                    ) : (
                                        <>
                                            <span className="gh-room-row-name">{room.name}</span>
                                            <span className="gh-room-row-cap">до {room.capacity} чел.</span>
                                            <button className="gh-room-row-edit" onClick={() => startEditRoom(room)}>✎</button>
                                            <button className="gh-guest-remove" onClick={() => deleteRoom(room.id, room.name)}>✕</button>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="gh-modal-section">
                            <label>ДОБАВИТЬ КОМНАТУ</label>
                            <div className="gh-form-row-2">
                                <input
                                    className="gh-date-input"
                                    placeholder="Название"
                                    value={newRoomName}
                                    onChange={(e) => setNewRoomName(e.target.value)}
                                />
                                <input
                                    type="number"
                                    min={1}
                                    className="gh-date-input"
                                    placeholder="Вместимость"
                                    value={newRoomCapacity}
                                    onChange={(e) => setNewRoomCapacity(e.target.value)}
                                />
                            </div>
                            <button className="gh-btn-save" style={{ width: "100%" }} onClick={addRoom}>
                                + Добавить
                            </button>
                        </div>

                        <div className="gh-modal-actions">
                            <button className="gh-btn-cancel" onClick={() => setRoomsModal(false)}>
                                Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Модалка "Добавить/Изменить бронь" ── */}
            {canEdit && orderModal.open && (
                <div className="gh-overlay" onClick={() => setOrderModal({ open: false })}>
                    <div className="gh-modal gh-order-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="gh-modal-header">
                            <h2>{editingOrderId ? "Изменить бронь" : "Добавить бронь"}</h2>
                            <button className="gh-modal-close" onClick={() => setOrderModal({ open: false })}>✕</button>
                        </div>

                        <div className="gh-modal-section">
                            <div className="gh-form-row-2">
                                <div>
                                    <span className="gh-flabel">Заезд</span>
                                    <input
                                        type="date"
                                        className="gh-date-input"
                                        value={orderStart}
                                        onChange={(e) => setOrderStart(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <span className="gh-flabel">Выезд</span>
                                    <input
                                        type="date"
                                        className="gh-date-input"
                                        value={orderEnd}
                                        onChange={(e) => setOrderEnd(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="gh-form-row-2">
                                <div>
                                    <span className="gh-flabel">Цена проживания (общая) $</span>
                                    <input
                                        type="number"
                                        min={0}
                                        className="gh-date-input"
                                        value={orderPrice}
                                        onChange={(e) => setOrderPrice(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <span className="gh-flabel">Ночей</span>
                                    <div className="gh-nights-badge">{nightsBetween(orderStart, orderEnd)}</div>
                                </div>
                            </div>

                            <div className="gh-meal-box">
                                <div className="gh-meal-box-title">Питание (за всё проживание)</div>
                                <div className="gh-meal-row">
                                    <label className="gh-meal-label-row">
                                        <input
                                            type="checkbox"
                                            checked={orderMealBreakfast}
                                            onChange={(e) => setOrderMealBreakfast(e.target.checked)}
                                        />
                                        Завтрак
                                    </label>
                                    <span>
                                        $
                                        <input
                                            type="number"
                                            min={0}
                                            className="gh-meal-price-input"
                                            value={orderMealBreakfastPrice}
                                            onChange={(e) => setOrderMealBreakfastPrice(e.target.value)}
                                        />
                                    </span>
                                </div>
                                <div className="gh-meal-row">
                                    <label className="gh-meal-label-row">
                                        <input
                                            type="checkbox"
                                            checked={orderMealDinner}
                                            onChange={(e) => setOrderMealDinner(e.target.checked)}
                                        />
                                        Ужин
                                    </label>
                                    <span>
                                        $
                                        <input
                                            type="number"
                                            min={0}
                                            className="gh-meal-price-input"
                                            value={orderMealDinnerPrice}
                                            onChange={(e) => setOrderMealDinnerPrice(e.target.value)}
                                        />
                                    </span>
                                </div>
                            </div>

                            <span className="gh-flabel">Доп. услуги (Название, Цена $)</span>
                            {orderExtraServices.map((s, idx) => (
                                <div className="gh-extra-service-row" key={idx}>
                                    <input
                                        placeholder="Название услуги"
                                        value={s.name}
                                        onChange={(e) => updateExtraService(idx, "name", e.target.value)}
                                    />
                                    <input
                                        type="number"
                                        min={0}
                                        placeholder="Цена"
                                        value={s.price}
                                        onChange={(e) => updateExtraService(idx, "price", e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="gh-guest-remove"
                                        onClick={() => removeExtraService(idx)}
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                            <div className="gh-add-guest-btn" onClick={addExtraService}>+ Добавить услугу</div>

                            <div className="gh-guest-slots-title">Гости</div>
                            {orderGuests.map((g, idx) => (
                                <div className="gh-guest-slot" key={idx}>
                                    <div className="gh-guest-slot-head">
                                        <span>Гость {idx + 1}</span>
                                        {orderGuests.length > 1 && (
                                            <button
                                                type="button"
                                                className="gh-guest-remove"
                                                onClick={() => removeOrderGuestSlot(idx)}
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>
                                    <div className="gh-guest-grid">
                                        <input
                                            placeholder="Имя Фамилия"
                                            value={g.name}
                                            onChange={(e) => updateOrderGuestField(idx, "name", e.target.value)}
                                        />
                                        <input
                                            placeholder="Страна"
                                            value={g.country}
                                            onChange={(e) => updateOrderGuestField(idx, "country", e.target.value)}
                                        />
                                        <input
                                            placeholder="Паспорт"
                                            value={g.passport}
                                            onChange={(e) => updateOrderGuestField(idx, "passport", e.target.value)}
                                        />
                                        <select
                                            value={g.pay}
                                            onChange={(e) => updateOrderGuestField(idx, "pay", e.target.value)}
                                        >
                                            <option value="cash">Наличка</option>
                                            <option value="terminal">Терминал</option>
                                            <option value="click">Click</option>
                                            <option value="debt">Долг</option>
                                        </select>
                                    </div>
                                </div>
                            ))}
                            <div className="gh-add-guest-btn" onClick={addOrderGuestSlot}>+ Добавить гостя</div>

                            <input
                                className="gh-note-input"
                                placeholder="Заметка (необязательно)"
                                value={orderNote}
                                onChange={(e) => setOrderNote(e.target.value)}
                            />

                            <div className="gh-calc-box">
                                <div className="gh-calc-row"><span>Проживание</span><span>${orderPrice || 0}</span></div>
                                {orderMealBreakfast && (
                                    <div className="gh-calc-row"><span>Завтрак</span><span>${orderMealBreakfastPrice || 0}</span></div>
                                )}
                                {orderMealDinner && (
                                    <div className="gh-calc-row"><span>Ужин</span><span>${orderMealDinnerPrice || 0}</span></div>
                                )}
                                {orderExtraServices.filter((s) => s.name.trim()).map((s, i) => (
                                    <div className="gh-calc-row" key={i}><span>{s.name}</span><span>${s.price || 0}</span></div>
                                ))}
                                <div className="gh-calc-row gh-calc-total"><span>Итого</span><span>${orderTotal()}</span></div>
                            </div>
                        </div>

                        <div className="gh-modal-actions">
                            <button className="gh-btn-cancel" onClick={() => setOrderModal({ open: false })}>
                                Отмена
                            </button>
                            <button className="gh-btn-save" onClick={saveOrder}>
                                {editingOrderId ? "Сохранить изменения" : "Создать бронь"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Карточка деталей брони ── */}
            {viewOrder && (
                <div className="gh-overlay" onClick={() => setViewOrder(null)}>
                    <div className="gh-modal gh-order-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="gh-modal-header">
                            <h2>№{viewOrder.orderNumber} — {viewOrder.title}</h2>
                            <button className="gh-modal-close" onClick={() => setViewOrder(null)}>✕</button>
                        </div>

                        <div className="gh-modal-info">
                            <div className="gh-info-row"><span>Заезд</span><b>{viewOrder.dateStart}</b></div>
                            <div className="gh-info-row"><span>Выезд</span><b>{viewOrder.dateEnd}</b></div>
                            <div className="gh-info-row"><span>Ночей</span><b>{nightsBetween(viewOrder.dateStart, viewOrder.dateEnd)}</b></div>
                            <div className="gh-info-row"><span>Гостей</span><b>{viewOrder.participantsCount}</b></div>
                            <div className="gh-info-row">
                                <span>Распределено</span>
                                <b className={viewOrder.assignedCount >= viewOrder.participantsCount ? "gh-text-ok" : "gh-text-pending"}>
                                    {viewOrder.assignedCount} / {viewOrder.participantsCount}
                                </b>
                            </div>
                            <div className="gh-info-row"><span>Комнаты</span><b>{viewOrder.rooms.length ? viewOrder.rooms.map((r) => `${r.name} (${r.count})`).join(", ") : "—"}</b></div>
                        </div>

                        <div className="gh-guest-slots-title">Гости</div>
                        {viewOrder.guests.map((g, idx) => (
                            <div className="gh-guest-card" key={idx}>
                                <div className="gh-guest-card-name">{g.name}</div>
                                <div className="gh-guest-card-grid">
                                    <div><span className="gh-flabel">Страна</span><div>{g.country || "—"}</div></div>
                                    <div><span className="gh-flabel">Оплата</span><div>{g.pay ? (payLabel[g.pay] || g.pay) : "—"}</div></div>
                                    <div style={{ gridColumn: "1 / -1" }}><span className="gh-flabel">Паспорт</span><div>{g.passport || "—"}</div></div>
                                </div>
                            </div>
                        ))}

                        <div className="gh-calc-box">
                            <div className="gh-calc-row"><span>Проживание</span><span>${viewOrder.price}</span></div>
                            {viewOrder.mealBreakfast && (
                                <div className="gh-calc-row"><span>Завтрак</span><span>${viewOrder.mealBreakfastPrice}</span></div>
                            )}
                            {viewOrder.mealDinner && (
                                <div className="gh-calc-row"><span>Ужин</span><span>${viewOrder.mealDinnerPrice}</span></div>
                            )}
                            {viewOrder.extraServices.map((s, i) => (
                                <div className="gh-calc-row" key={i}><span>{s.name}</span><span>${s.price}</span></div>
                            ))}
                            <div className="gh-calc-row gh-calc-total">
                                <span>Итого</span>
                                <span>
                                    ${viewOrder.price +
                                        (viewOrder.mealBreakfast ? viewOrder.mealBreakfastPrice : 0) +
                                        (viewOrder.mealDinner ? viewOrder.mealDinnerPrice : 0) +
                                        viewOrder.extraServices.reduce((s, x) => s + (Number(x.price) || 0), 0)}
                                </span>
                            </div>
                        </div>

                        {viewOrder.note && (
                            <div className="gh-note-display">{viewOrder.note}</div>
                        )}

                        <div className="gh-modal-actions">
                            <button className="gh-btn-cancel" onClick={() => setViewOrder(null)}>Закрыть</button>
                            {canEdit && (
                                <button
                                    className="gh-btn-save"
                                    onClick={() => {
                                        setViewOrder(null);
                                        openOrderModal(viewOrder);
                                    }}
                                >
                                    Изменить
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GuestHouse;